import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { MenuItem } from '../MenuItem';
import { IBackToPortalMenuItem } from './interfaces';

export const BackToPortalMenuItem: React.FC<IBackToPortalMenuItem> = ({
  onNavigate,
}): JSX.Element => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <MenuItem
      icon={<ArrowBackIcon fontSize="small" />}
      label={t('modules:switcher.backToPortal.label')}
      onClick={() => {
        navigate('/');
        onNavigate?.();
      }}
      key="back-to-portal"
      active={false}
      gutter
      sxButton={{
        backgroundColor: theme.palette.grey[100],
        border: `1px solid ${theme.palette.grey[300]}`,
        '&:hover': {
          backgroundColor: theme.palette.grey[200],
        },
      }}
    />
  );
};
